
const validate = (values) => {
  const errors = {};

  if (values.url && !/\S/.test(values.url)) {
    errors.url = 'Field cannot be empty';
  }

  return errors;
};

export default validate;
